import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, take, tap} from 'rxjs/operators';
import { RoleEntity } from '../entities/role.entity';
import { State } from '../State';
import { getRoles } from '../State/selectors/permissions.selectors';
import { ResolverLoadRoles } from '../State/actions/resolver.actions';

@Injectable({
    providedIn: 'root'
})
export class RolesResolver implements Resolve<RoleEntity[]> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getRoles);

        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                        this.store.dispatch(new ResolverLoadRoles());
                    }
                })
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1)
        );
    }
}
